import React from "react";
import { Typography } from "@mui/material";

interface OtpCountDownProps {
  timeLeft: number;
}

const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
};

const OtpCountDown: React.FC<OtpCountDownProps> = ({ timeLeft }) => {
  if (timeLeft <= 0) return null;

  return (
    <Typography
      sx={{
        textAlign: "center",
        fontSize: "14px",
        marginTop: "7px",
        color: "red",
      }}
    >
      The OTP is expiring in {formatTime(timeLeft)} minutes
    </Typography>
  );
};

export default OtpCountDown;
